/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostOrdersOrderIdCancelMutationRequest, PostOrdersOrderIdCancelMutationResponse, PostOrdersOrderIdCancelPathParams, PostOrdersOrderIdCancel400 } from "../entities/PostOrdersOrderIdCancel";

function getPostOrdersOrderIdCancelUrl(order_id: PostOrdersOrderIdCancelPathParams["order_id"]) {
  const res = { method: 'POST', url: `/orders/${order_id}/cancel` as const }  
  return res
}

/**
 * @description Отмена заказа
 * @summary Отмена заказа
 * {@link /orders/:order_id/cancel}
 */
export async function postOrdersOrderIdCancel(order_id: PostOrdersOrderIdCancelPathParams["order_id"], data: PostOrdersOrderIdCancelMutationRequest, config: Partial<RequestConfig<PostOrdersOrderIdCancelMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostOrdersOrderIdCancelMutationResponse, ResponseErrorConfig<PostOrdersOrderIdCancel400>, PostOrdersOrderIdCancelMutationRequest>({ method : "POST", url : getPostOrdersOrderIdCancelUrl(order_id).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}